//1) CRIAR TABELA COR_PESSOA_ATIVO COM ATV_ATIVOS FORNECIDOS POR CADA COR_PESSOA
//2) ALTERAR CRUDPESSOA (OU CRIAR SERVICO) PARA INCLUIR OS ATIVOS PADRÃO NA COR_PESSOA_ATIVO
//3) REFAZER COR_ATIVIDADE*

const ATIVO_POSICAO = {
    O: { id: 'O', sigla: 'O', descricao: 'Operação' },
    D: { id: 'D', sigla: 'D', descricao: 'Consolidada por Data da Operação' },
    C: { id: 'C', sigla: 'C', descricao: 'Consolidada' }
};

module.exports = ATIVO_POSICAO;
